const label = {};
label.list = $('.label-choose');
label.item = $('.label-choose__item');

const onCLick = e => {

  let additional, data, parent, input;
  e.preventDefault();
  const target = e.currentTarget;
  if (target.classList.contains('active')) {
    return;
  }

  [parent, additional, data] = getAdditional($(target));

  input = getInput($(target));

  if (data) {
    input.attr('data-' + additional, data);
  }

  parent.find('.active').removeClass('active');
  $(target).addClass('active');
  input.val($(target).data('value')).change();
}

function getAdditional(item) {
  const parent = item.parents('.label-choose'),
    additional = parent.data('additional');

  let data;
  if (typeof additional !== 'undefined')
    data = item.data(additional);

  return [parent, additional, data];
}

function getInput(item) {
  const parent = item.parents('.label-choose'),
    name = parent.data('name');

  return $('[name=' + name + ']');
}

export const updateChoose = () => {
  label.item = label.list.find('.label-choose__item');
  label.item.click(onCLick);
}

label.item.click(onCLick);
